import { useParams } from 'react-router-dom'
import { BlogArticle, blogPostBySlug } from '@kkf/design'
import { POSTS } from '../data/blog'
import { SITE } from '../data/seo'

/**
 * One post, resolved from `/blog/:slug`.
 *
 * The page is `@kkf/design`'s `BlogArticle`, shared with the three ventures. This file is
 * the lookup and nothing else.
 *
 * **An unknown slug renders the article's not-found state rather than the first post.**
 * It fell back to `POSTS[0]` while one app had the whole blog, which serves somebody else's
 * article under the address you typed. Four apps now carry subsets of one library, so a
 * miss is an ordinary case — a link to a Garage post pasted into the Foundation's site is
 * not one here, but the reverse certainly is.
 *
 * `/blog/*` is in this app's `header.plainRoutes`; the prefix form is the only one that
 * covers a `:slug`. See `SiteShell`.
 */
export function BlogDetailsPage() {
  const { slug } = useParams()
  return <BlogArticle posts={POSTS} post={blogPostBySlug(POSTS, slug)} site={SITE} />
}
